<template>
  <div class="login" >
    <div class="loginBox">
      <div class = "logo-image-box">
        <img src="../images/new_logo.png" class="logo-image"/>
      </div>
      <!-- <img src="../images/atfx_logo.png" class="logo" /> -->
      <!-- <h2>{{loginLan.memberCenter}}</h2> -->
      <label>
        <img src="../images/ren.png" alt="" />
        <input v-model="fromValue.name" type="text" :placeholder="loginLan.loginTxt" @keyup.enter="loginFn" class="username-but">
      </label>
      <label>
        <img src="../images/suo.png" alt="" />
        <input v-model="fromValue.password" type="password" :placeholder="loginLan.passwordTxt" @keyup.enter="loginFn" class="username-but">
      </label>
      <div class="forgot-password-box">
        <span class="forgot-password">{{loginLan.forgotPassword}}</span>
      </div>
      <div class="login-but-box">
        <button @click='loginFn' class="login-but">{{loginLan.btn}}</button>
      </div>

      <div class="language">
        <div class="language-box"><span class="select_language-span">{{loginLan.select_language}}</span></div>
        <div class="select_language-box">
          <i class="el-icon-arrow-down"></i>
          <select name="language" id="language" ref="language" class="select-but" v-model="languageSelActive">
            <option v-for="(item,index) in languageSelList" :value="index">{{item}}</option>
            <!-- <option value="hk">繁體中文</option> -->
            <!-- <option value="en">English</option> -->
          </select>
        </div>

      </div>
    </div>
    <Modal v-model="modalShow" class="modal-content-j" size="sm" :footer="false" :header="false" :backdrop="true">
      <div style="font-size:16px; text-align:center; "><i class="glyphicon glyphicon-warning-sign color-red"></i>{{loginLan.tips.loginErr}}</div>
    </Modal>
  </div>
</template>

<script>
  import  {URL_FINDALLPRIVILEGE, URL_SINGIN,URL_FINDUSER } from 'api/api.js'
  import { URL_commissionLogin } from 'api/commissionApi'
  import { URL_commissionLogin20 } from 'api/commissionApi'
  import sidebarList from './../MultiLanguage/menuAllList'
  import { hiddenAreas } from '@/config';

  export default {
    name: "login",
    mixins: [
      require("common/mixin/base.js").base({loginLan:"login"}),
      require("common/mixin/modal.js").modal()
    ],
    data(){
      return{
        link: this.$route.query.link ? this.$route.query.link : '',
        fromValue: {
          name: "",
          password: ""
        },
        languageSelList: {
          cn: "简体中文",
          hk: "繁體中文",
          en: "English",
        },
        languageSelActive: localStorage.language  || "cn"
      }
    },
    mounted() {
      sessionStorage.setItem('UTCDIFF',new String(- new Date().getTimezoneOffset() / 60))
    },
    methods: {
      loginFn() {
        let p1 = this.$http.post(URL_SINGIN,{name: this.fromValue.name,password: this.fromValue.password})
        // let p2 = this.$http.post(URL_commissionLogin,{name:this.fromValue.name,password:this.fromValue.password})
        let p3 = this.$http.post(URL_commissionLogin20,{name:this.fromValue.name,password:this.fromValue.password})
        Promise.all([p1,p3]).then(res => {
            const resJson = res[0]['data'];
            if (resJson && resJson['code'] == 200 && resJson['data']) {
              let user = resJson['data'];
              sessionStorage.user = JSON.stringify(user)
              this.SAVEUSER(JSON.stringify(user));
              // var link = (user.purview == "admin")?"/userList":"/accountList";
              let privilege_request = this.$http.post(URL_FINDALLPRIVILEGE,{"role":user.purview})
              Promise.all([privilege_request]).then(res => {
                const resJson1 = res[0]['data'];
                let _role_id = [];
                resJson1.data.forEach(item => {
                  _role_id.push(item.right_id);
                })
                if (resJson1 && resJson1['code'] == 200 && resJson1['data']) {
                  sessionStorage.menuList = JSON.stringify(_role_id)
                  sessionStorage.rightObject = JSON.stringify(resJson1['data'])
                  var link = ''

                  for(let key in sidebarList){
                    const role_id = sidebarList[key].Role_ID
                    const index = _role_id.findIndex((element)=> {
                      return element.toString() === role_id.toString()
                    })
                    if (index > -1) {
                      link =  sidebarList[key].link;
                      break;
                    }
                  }
                  if (this.link) link = this.link
                  // else link = (user.purview == "admin")?"/userList":"/accountList"; // 暂时关闭 登录去用户列表或者账户列表
                  // else link = '/ib/ibSetting' // 暂时 登录去佣金设定页面
                  this.$router.push({
                    path: link
                  });
                }
              })

            } else {
              //TODO  友好提示
              this.modalShow = true
            }
            // let area = res[1].data.data.area
            // sessionStorage.area = JSON.stringify(area)
            let area20 = res[1].data.data.area.filter((area)=>!hiddenAreas.includes(area))
            let profitshare_area = res[1].data.data.profitshare_area
            sessionStorage.area20 = JSON.stringify(area20)
            sessionStorage.profitshare_area = JSON.stringify(profitshare_area)



            // let currentArea = {
            //   group: Object.keys(area)[0],
            //   value: area[Object.keys(area)[0]][0]
            // }
            // sessionStorage.currentArea = JSON.stringify(currentArea)
            let currentArea20 = {
              group: profitshare_area[0],
              value: area20[0],
            }
            sessionStorage.currentArea20 = JSON.stringify(currentArea20)
        })
      }
    },
    watch: {
      languageSelActive(curVal, oldVal) {
        this.SAVELANGUAGE(curVal);
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .login {
    /*background: url('../images/loginbg.jpg') center center;*/
      // position: absolute;
      // top: 0;
      // left: 0;
      // right: 0;
      // bottom: 0;
      // z-index: 99;
    .glyphicon{
      margin-right: 10px;
    }
    .loginBox {
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      background: white;
      z-index: 2;
      padding: 10px;
      height: 388px;
      width: 400px;
      border-radius: 8px;
      padding: 32px 56px 32px 56px;
      border-radius: 8px;
      box-shadow: 0px 12px 28px 0px rgba(6,18,38,0.08);

      .login-but-box {
        margin-top: 24px;
        .login-but {
          height: 40px;
          width: 288px;
          left: 56px;
          top: 260px;
          border-radius: 4px;
          padding: 5px 16px 5px 16px;
          background: #0F2C52;

        }
      }
      .forgot-password-box{
        //styleName: Regular / 14px | 22px;

        .forgot-password {
          display: block;
          text-align: right;
          font-family: Helvetica;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0px;
        }
      }

      .logo-image-box {
        flex-direction: row;
        margin-bottom: 25px;
        .logo-image{
          width: 125px;
        }
      }
      .username-but {
        height: 40px;
        width: 288px;
        left: 0px;
        top: 54px;
        border-radius: 4px;

      }

      .logo {
        width: 139px;
        // height: 58px;
        margin-top: 50px;
        margin-bottom: 20px;
      }
      h2 {
        font-size: 16px;
        line-height: 25px;
        margin-bottom: 30px;
        margin-top: 0;
        color: black;
        font-weight: normal;
      }
      label {
        width: 100%;
        height: 40px;
        position: relative;
        margin-bottom: 24px;
        display: block;
        img {
              width: 16px;
              /* height: 25px; */
              position: absolute;
              top: 12px;
              left: 12px;
        }
        input {
          width: 100%;
          height: 42px;
          display: block;
          padding: 0;
          border: 1px solid #E8E8E8;
          padding-left: 35px;
          box-sizing: border-box;
        }
        .palceholder{
          position: absolute;
          left:35px;
          top:10px;
          color:#757575;
        }
      }
      .verification {
        width: 100%;
        height: 60px;
        label {
          float: left;
          width: 120px;
          height: 40px;
          padding: none;
          input {
            width: 100%;
            height: 100%;
            display: block;
            border: 1px solid #BABABA;
            padding-left: 0;
            text-align: center;
          }
          .palceholder{
            position: absolute;
            width: 100%;
            text-align: center;
            padding-left:0;
            left:0;
            color:#757575;
          }
        }
        img {
          float: right;
          width: 150px;
          height: 40px;
          cursor: pointer;
        }
      }
      button {
        width: 100%;
        height: 30px;
        padding: 7px 12px;
        box-sizing: border-box;
        font-size: 13px;
        border-radius: 3px;
        text-align: center;
        line-height: 17px;
        border: none;
        color: #fff;
        margin-bottom: 30px;
        cursor: pointer;
      }
      .language {
        display:flex;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 5px;
        .language-box{
          width: 66px;
          .select_language-span{
            display: block;
            text-align: right;
            line-height: 32px;
          }
        }
        .select_language-box{
          position: relative;
          .el-icon-arrow-down{
            position: absolute;
            top: 9px;
            right: 12px;
            z-index: -1;
          }
          .select-but{
            height: 32px;
            width: 210px;
            left: 78px;
            top: 0px;
            border-radius: 4px;
            padding: 4px 12px 6px 12px;
            appearance: none;
            background: transparent;
          }
          select{
             border: 1px solid #E8E8E8
          }
        }
      }
    }
  }

</style>





// WEBPACK FOOTER //
// login.vue?47893434